import React from "react";
import {
  GOVGR_BODY,
  GOVGR_GRID_COLUMN_TWO_THIRDS,
  GOVGR_HEADING_XL,
  GOVGR_MAIN_WRAPPER,
  GOVGR_WIDTH_CONTAINER,
} from "../../conf/styles/GovGr404Page";

const GovGr404Page = ({
  translations = {
    heading: "Η σελίδα δεν βρέθηκε",

    p1: " Έαν έχετε πληκτρολογήσει την διεύθυνση της σελίδας, ελέγξτε ότι είναι σωστή.",

    p2: "Εάν έχετε επικολλήσει τη διεύθυνση της σελίδας, ελέγξτε ότι την έχετε αντιγράψει ολόκληρη τη διεύθυνση.",

    p3: "Εάν η διεύθυνση της σελίδας είναι σωστή ή έχετε επιλέξει έναν σύνδεσμο ή κουμπί, επικοινωνήστε με το γραφείο υποστήριξης σε περίπτωση που χρειάζεστε βοήθεια.",
  },
}) => {
  return (
    <div className={`${GOVGR_WIDTH_CONTAINER}`}>
      <div className={`${GOVGR_MAIN_WRAPPER}`}>
        <main className={`${GOVGR_GRID_COLUMN_TWO_THIRDS}`}>
          <h1 className={`${GOVGR_HEADING_XL}`}>{translations.heading}</h1>
          <p className={`${GOVGR_BODY}`}>{translations.p1}</p>
          <p className={`${GOVGR_BODY}`}>{translations.p2}</p>
          <p className={`${GOVGR_BODY}`}>{translations.p3}</p>
        </main>
      </div>
    </div>
  );
};

export default GovGr404Page;
